import React, { useContext, useEffect, useState, useCallback  } from 'react';
import fetchCategoryWiseProduct from '../helpers/fetchCategoryWiseProduct';
import displayINRCurrency from '../helpers/displayCurrency';
import { Link } from 'react-router-dom';
import addToCart from '../helpers/addToCart';
import Context from '../context';
import scrollTop from '../helpers/scrollTop';

const CategoryWiseProductDisplay = ({ category, heading }) => {
    const [ data, setData ] = useState([])
    const [ loading, setLoading ] = useState(true)
    const loadingList = new Array(13).fill(null)

    const { fetchUserAddToCart } = useContext(Context);

    const handleAddToCart = async (e, id, isOutOfStock) => {
        e.preventDefault();
        e.stopPropagation();

        if(isOutOfStock) return;

        await addToCart(e, id)
        fetchUserAddToCart()
    }

    const fetchData = useCallback(async () => {
         if (!category) return;
        setLoading(true)
        const categoryProduct = await fetchCategoryWiseProduct(category)
        setLoading(false)

        //console.log("Fetched Data:", categoryProduct.data);

        setData(categoryProduct?.data || [])
    }, [category]);

    useEffect(()=>{
        if (!category) return;
        fetchData()
    },[fetchData, category])


  return (
    <div className='container mx-auto px-10 py-4 relative'>
        <h2 className='text-2xl font-semibold py-4'>{heading}</h2>

        <div className='grid grid-cols-[repeat(auto-fit,minmax(300px,320px))] justify-between gap-4 md:gap-6'>
        
            { loading ? (
                loadingList.map((product, index)=>{
                return(
                    <div className='w-full min-w-[280px] md:min-w-[320px] max-w-[280px] md:max-w-[320px] bg-white rounded-sm shadow-md'>
                        <div className='bg-white h-52 p-4 min-w-[120px] md:min-w-[145px] flex justify-center items-center animate-pulse'>
                        </div>
                        <div className='p-4 grid gap-3'>
                            <p className='font-medium text-base md:text-lg text-ellipsis line-clamp-1 text-black p-1 py-2 animate-pulse rounded-full bg-white'></p>
                            <p className='capitalize text-slate-500 p-1 py-2 animate-pulse rounded-full bg-white'></p>
                            <div className='flex gap-3'>
                                <p className='text-green-600 font-medium p-1 py-2 animate-pulse rounded-full bg-white w-full'></p>
                                <p className='text-slate-500 line-through p-1 py-2 animate-pulse rounded-full bg-white w-full'></p>
                            </div>
                            <button className='text-sm text-white px-6 py-2 rounded-full animate-pulse bg-white'></button>
                        </div>
                    </div>
                    ) 
                })
            ) : (
                data.map((product)=>{
                
                const isOutOfStock = product?.stock === 0;

                return(
                     <div key={product?._id} className='mt-4 md:mt-0 w-full min-w-[280px] md:min-w-[320px] max-w-[280px] md:max-w-[320px] bg-white rounded shadow-md border border-slate-400 overflow-hidden relative'>
                        {/* OUT OF STOCK BADGE */}
                        {isOutOfStock && (
                            <span className='absolute top-2 left-2 bg-red-600 text-white text-xs px-2 py-1 rounded z-10'>
                              Out of Stock
                            </span>
                        )}
                        
                        <Link key={product?._id} to={"/product/"+product?._id} onClick={scrollTop}>
                            <div className='bg-white h-64'>
                                <img src={product.productImage[0]} 
                                className={`object-scale-down w-full h-full mix-blend-multiply transition-all
                                    ${isOutOfStock ? "opacity-60" : "hover:scale-100"}`} alt=''/>
                            </div>
                            <div className='p-4 grid'>
                                <h2 className='font-medium text-base md:text-lg text-ellipsis line-clamp-1 text-orange-950'>{product?.productName}</h2>
                                <p className='capitalize text-orange-900 text-sm'>{product?.category}</p>
                                <div className='flex gap-3'>
                                    <p className='text-orange-950 font-medium'>{ displayINRCurrency(product?.sellingPrice) }</p>
                                    <p className='text-orange-900 line-through'>{ displayINRCurrency(product?.price) }</p>
                                </div>
                            </div>
                            </Link>
                                <div className='p-4 pt-0 flex justify-center'>
                                    <Link to={"product/" + product?._id}>  
                                        <button className='text-sm px-5 border-[#5a3620] font-medium py-2 w-28 rounded border-2 text-[#5a3620] mr-3'>
                                            View More
                                        </button>
                                    </Link>

                                    <button
                                        disabled={isOutOfStock}
                                        onClick={(e)=>handleAddToCart(e,product?._id,isOutOfStock)}
                                        className={`text-sm px-4 py-2 w-36 rounded 
                                          ${isOutOfStock 
                                            ? "bg-gray-400 cursor-not-allowed text-white"
                                            : "bg-[#5a3620] text-white"
                                          }`}>
                                        {isOutOfStock ? "Out of Stock" : "Add to Cart"}
                                    </button>                            
                                </div>
                            </div>
                    ) 
                })
                )
            }
        </div>
    </div>

  )
}

export default CategoryWiseProductDisplay;